import React, { useState, useContext } from "react";
import { Button, Input } from "antd";
import { AuthContext } from "../../../../contexts/AuthContext";
import LoadingAction from "../../../../themes/LoadingAction/LoadingAction";
import { useNavigate } from "react-router-dom";
import * as links from "../../../../utils/links";
import "./ResetSenha.css";
import axios from "axios";

const ResetSenha = () => {
  const [currentPassword, setCurrentPassword] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({
    password: "",
    confirmPassword: "",
  });

  const { authInfo, setNotiMessage, setDataUser } = useContext(AuthContext);
  const navigate = useNavigate();
  const token = authInfo?.dataUser?.token;
  const isAdmin = authInfo?.dataUser?.key === "ADMIN";
  const minimoSenha = isAdmin ? 8 : 6;

  const validatePassword = (value) => {
    if (value.length < minimoSenha && value !== "") {
      return `A senha precisa ter no mínimo ${minimoSenha} caracteres.`;
    }
    return "";
  };

  const validateConfirmPassword = (value, novaSenha = password) => {
    if (value !== novaSenha && value !== "") {
      return "As senhas não coincidem.";
    }
    return "";
  };

  const handlePasswordChange = (value) => {
    setPassword(value);
    setErrors((prev) => ({
      ...prev,
      password: validatePassword(value),
      confirmPassword: validateConfirmPassword(confirmPassword, value),
    }));
  };

  const handleConfirmPasswordChange = (value) => {
    setConfirmPassword(value);
    setErrors((prev) => ({
      ...prev,
      confirmPassword: validateConfirmPassword(value),
    }));
  };

  const onNewPassword = async () => {
    setIsLoading(true);
    const headers = {
      "x-access-token": token,
      "content-type": "application/json",
    };

    try {
      if (isAdmin) {
        await axios.put(
          `${process.env.REACT_APP_SERVIDOR}/admin-2027/seguranca/senha`,
          {
            senhaAtual: currentPassword,
            newPassword: password,
            confirmPassword,
          },
          { headers }
        );
      } else {
        await axios.post(
          `${process.env.REACT_APP_SERVIDOR}/cliente-trocar-senha-himself`,
          { newPassword: password },
          { headers }
        );
      }

      setNotiMessage({
        type: "success",
        message: isAdmin
          ? "Senha administrativa alterada. Entre novamente com a nova senha."
          : "Senha redefinida com sucesso!",
      });
      setDataUser(null);
      navigate(links.SIGNIN);
    } catch (err) {
      setNotiMessage({
        type: "error",
        message: err.response?.data?.error || "Não foi possível alterar a senha.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const onSave = () => {
    const formularioValido =
      !errors.password &&
      !errors.confirmPassword &&
      password.length >= minimoSenha &&
      confirmPassword === password &&
      (!isAdmin || currentPassword);

    if (formularioValido) onNewPassword();
  };

  return (
    <div className="ResetSenha_container">
      {isLoading && <LoadingAction />}
      <h2>{isAdmin ? "Trocar Senha do Administrador" : "Redefinir Senha"}</h2>

      {isAdmin && (
        <div className="ResetSenha_field">
          <label htmlFor="currentPassword">Senha Atual:</label>
          <Input.Password
            id="currentPassword"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            placeholder="Digite sua senha atual"
            autoComplete="current-password"
          />
        </div>
      )}

      <div className="ResetSenha_field">
        <label htmlFor="password">Nova Senha:</label>
        <Input.Password
          id="password"
          value={password}
          onChange={(e) => handlePasswordChange(e.target.value)}
          placeholder="Digite sua nova senha"
          status={errors.password ? "error" : ""}
          autoComplete="new-password"
        />
        {errors.password && (
          <div className="ResetSenha_errorMessage">{errors.password}</div>
        )}
      </div>

      <div className="ResetSenha_field">
        <label htmlFor="confirmPassword">Repita sua Nova Senha:</label>
        <Input.Password
          id="confirmPassword"
          value={confirmPassword}
          onChange={(e) => handleConfirmPasswordChange(e.target.value)}
          placeholder="Confirme sua nova senha"
          status={errors.confirmPassword ? "error" : ""}
          autoComplete="new-password"
        />
        {errors.confirmPassword && (
          <div className="ResetSenha_errorMessage">{errors.confirmPassword}</div>
        )}
      </div>

      <Button
        type="primary"
        className="Edit_Cliente_saveBtn"
        onClick={onSave}
        disabled={
          Boolean(errors.password) ||
          Boolean(errors.confirmPassword) ||
          password.length < minimoSenha ||
          confirmPassword !== password ||
          (isAdmin && !currentPassword)
        }
      >
        {isAdmin ? "Alterar Senha Administrativa" : "Trocar Minha Senha"}
      </Button>
    </div>
  );
};

export default ResetSenha;
